module.exports = __webpack_public_path__ + "static/media/JunctionX_nav.7ae57dd0.png";